import NewsItem from 'components/NewsItem/NewsItem';
import Shadow from 'components/Shadow/Shadow';
import withWindowState, { WithWindowState } from 'enhancers/withWindowState';
import { uniqBy } from 'lodash';
import * as React from 'react';
import styled from 'styled-components';
import { INewsItem } from 'types/news';
import Section from 'wrappers/Section/Section';

interface IProps {
  localNews?: INewsItem[];
  globalNews?: INewsItem[];
  localFeatured?: INewsItem;
  globalFeatured?: INewsItem;
  loading: boolean;
  className?: string;
  title: string | null;
  readMoreText: string;
}

type Props = IProps & WithWindowState;

export const NewsSection: React.SFC<Props> = props => {
  const getFeaturedItem = () =>
    props.globalFeatured
      ? props.globalFeatured
      : props.localFeatured
      ? props.localFeatured
      : undefined;

  const getOtherItems = () => {
    const globalOthers = (props.globalNews ? props.globalNews : []).map(
      item => ({ ...item, global: true })
    );
    const localOthers = props.localNews ? props.localNews : [];
    const both: Array<INewsItem & { global?: boolean }> = [
      ...globalOthers,
      ...localOthers
    ].filter(article => !article.featured || article.featured === 'no');
    return uniqBy(both, item => item.id).slice(0, 2);
  };

  const featuredItem = getFeaturedItem();
  return (
    <Section className={props.className}>
      <Title>{props.title || ''}</Title>
      {/* title is 'Latest News' */}
      <Content>
        {featuredItem && (
          <TopNews>
            <FeaturedContainer>
              <NewsItem
                featured={true}
                readMoreText={props.readMoreText}
                item={featuredItem}
              />
            </FeaturedContainer>
            <OtherContainer>
              {getOtherItems().map(item => (
                <ItemContainer key={item.id}>
                  <NewsItem
                    imageHeight={100}
                    item={item}
                    readMoreText={props.readMoreText}
                  />
                </ItemContainer>
              ))}
            </OtherContainer>
          </TopNews>
        )}
      </Content>
    </Section>
  );
};

const OtherContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Title = styled.h2`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 40px;
`;

const Content = styled.div`
  /* justify-content: space-between; */
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`;

// const ItemWrapper = styled.div`
//   width: 30%;
//   display: inline-block;
//   @media (max-width: 1400px) {
//     width: 100%;
//     flex: 1;
//   }
// `;

const FeaturedContainer = styled(Shadow)`
  @media (max-width: 750px) {
    margin-right: initial;
    margin-bottom: 30px;
  }
`;

const TopNews = styled.div`
  display: flex;
  margin-bottom: 30px;
  ${FeaturedContainer} {
    flex: 1;
    margin-right: 10px;
  }
  ${OtherContainer} {
    margin-left: 10px;

    flex: 0 0 350px;
  }
  @media (max-width: 750px) {
    flex-direction: column;
    ${FeaturedContainer} {
      flex: 1;
    }
    ${OtherContainer} {
      flex: 1;
    }
  }
`;

const ItemContainer = styled(Shadow)`
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export default withWindowState(NewsSection);



// WEBPACK FOOTER //
// ./src/components/NewsSection/NewsSection.tsx